<template>
  <div class="docs">
    <DocsMenu :menu="menu" :slug="path" slug-property-name="path"></DocsMenu>
    <div class="docs__content">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-html="html"></div>
      <div class="docs__navigation">
        <Button
          v-if="previous !== null"
          tag="nuxt-link"
          :to="{ name: 'dev-docs', params: { path: previous.path } }"
          size="large"
          icon="iconoir-arrow-left"
          type="secondary"
        >
          {{ previous.name }}</Button
        >

        <Button
          v-if="next !== null"
          class="docs__navigation-right"
          tag="nuxt-link"
          :to="{ name: 'dev-docs', params: { path: next.path } }"
          size="large"
          append-icon="iconoir-arrow-right"
          type="secondary"
        >
          {{ next.name }}</Button
        >
      </div>
    </div>
    <DocsTOC :toc="toc"></DocsTOC>
  </div>
</template>

<script>
import DevDocsService from '@saas/services/devDocs'
import { MarkdownPage } from '@saas/markdown/markdownPage'
import DocsMenu from '@saas/components/docs/DocsMenu'
import DocsTOC from '@saas/components/docs/DocsTOC'

export default {
  components: { DocsMenu, DocsTOC },
  layout: 'docs',
  async asyncData({ error, params, app }) {
    const pathParam = params.path || 'index'
    const data = { path: params.path }
    let page

    // Fetch the markdown page from the backend.
    try {
      page = await DevDocsService(app.$client).get(pathParam)
    } catch (e) {
      return error({ statusCode: 404, message: 'Page not found.' })
    }

    // Render the markdown as html and extract the table of contents.
    const markdownPage = new MarkdownPage(
      '/docs/' + pathParam,
      page.data.markdown,
      app.$config
    )
    data.html = markdownPage.html
    data.toc = markdownPage.toc
    data.title = markdownPage.title

    // Add the open attribute to the groups.
    data.menu = page.data.sidebar.map((item) => {
      item.open = item.children.find((child) => child.path === pathParam)
      return item
    })

    data.previous = page.data.previous
    data.next = page.data.next

    return data
  },
  head() {
    return {
      title: this.title,
      link: [
        {
          rel: 'canonical',
          href:
            this.$config.PUBLIC_WEB_FRONTEND_URL +
            this.$route.path.replace(/%2F/g, '/'),
        },
      ],
    }
  },
}
</script>
